import React,{useState,useContext} from 'react'
// import Divider from "@material-ui/core/Divider"
import {makeStyles} from "@material-ui/core/styles"
import TextField from "@material-ui/core/TextField"
import Button from "../../../../../../../components/Button/ProgressiveButton"
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// import FormControl from '@material-ui/core/FormControl';
// import FormLabel from '@material-ui/core/FormLabel';
import {useValidator,TYPES} from "../../../../../../../hooks/useValidator";
import toEn from "../../../../../../../fns/toEn"
import SaveIcon from '@material-ui/icons/Save';
import axios from "../../../../../../../api/axios";
import {store as mainStore} from "../../../../../../../store";
import {store} from "../Customer"
import { useParams } from 'react-router-dom';
import YesNo from "../../../../../../../components/Dialog/YesNo"

const useStyles = makeStyles(theme=>({
  root:{
    display: 'grid',
    gridTemplateColumns:'1fr',
    gridGap:theme.spacing(1)
  }
}))

const EditPhone = ({phone,onClose}) => {
  const classes = useStyles();
  const initialState = {
      form:{
        phoneTitle:'',
        phoneNumber:'',
        phoneExt:'',
        phoneDescription:'',
        phoneIcon:'mobile',
        ...phone
      },
      inProgress:false
   }
  const [state,setState] = useState(initialState);
  const {form:{phoneTitle,phoneNumber,phoneExt,phoneDescription,phoneIcon,_id},inProgress} = state;
  
  // Defining validation variables
  const validators = {
    phoneNumber: [{ type: TYPES.REQUIRED }],
  };
  const {id} = useParams();
  // error variable and validate function.
  const [errors, validate] = useValidator(validators);
  const {showMessage,showError} = useContext(mainStore);
  const {refresh} = useContext(store);

  const handleChangeTextField = e=>{
    let {name,value} = e.target;
    if(name==='phoneNumber') value = toEn(value)
    setState(prev=>({...prev,form:{...prev.form,[name]:value}}))
  }
  const handleChangePhoneIcon = e=>{
    const {checked,value} = e.target;
    setState(prev=>({...prev,form:{...prev.form,phoneIcon:value}}))
  }
  const handleSubmit = async(e)=>{
    e?.preventDefault();
    setState({...state,inProgress:true})
    if(validate({phoneNumber})){
      try {
        const {data} = await axios.put(`/api/v1/admin/users/editPhone`,{
          phoneTitle,phoneExt,phoneDescription,phoneIcon,phoneId:_id
        });
        if(data?.ok) showMessage(data?.messages)
        refresh('fetchCustomerPhones');
        setState(initialState);
      } catch (error) {
        showError(error);
        setState({...state,inProgress:false})
      }
    }
    else setState({...state,inProgress:false})
  }
  const handleCloseDialog = async(agree)=>{
      if(agree){
        handleSubmit();
        onClose();
      }else onClose()
  }

  return (
      <>
    <YesNo 
        yes="ویرایش"
        no="صرفنظر"
        inProgress={inProgress}
        title="ویرایش تلفن"
        open={true}
        onClose={handleCloseDialog}
    >
            <form className={classes.root} onSubmit={handleSubmit} onKeyPress={(e) => {e.key === 'Enter' && handleSubmit(e);}}>
            <TextField 
                name="phoneTitle"
                variant="standard"
                label="عنوان شخص"
                value={phoneTitle}
                onChange={handleChangeTextField}
                disabled={inProgress}
            />
            <TextField 
                name="phoneNumber"
                variant="standard"
                label="شماره تلفن - غیر قابل ویرایش"
                value={phoneNumber}
                onChange={handleChangeTextField}
                disabled={inProgress}
                error={errors?.phoneNumber?true:false}
                helperText={errors?.phoneNumber?"وارد کردن شماره تلفن الزامی است":''}
                onBlur={validate}
                disabled
            />
            <TextField 
                name="phoneExt"
                variant="standard"
                label="شماره داخلی - برای مثال: ۱۰۱-۱۱۴"
                value={phoneExt}
                onChange={handleChangeTextField}
                disabled={inProgress}
            />
            <TextField 
                name="phoneDescription"
                variant="standard"
                label="توضیح مختصر"
                multiline
                rows={4}
                value={phoneDescription}
                onChange={handleChangeTextField}
                disabled={inProgress}
            />
            <RadioGroup row name="phoneIcon" defaultValue="mobile">
                
                <FormControlLabel checked={phoneIcon==='mobile'} value="mobile" control={<Radio color="secondary" onChange={handleChangePhoneIcon} disabled={inProgress} />} label="موبایل" />
                <FormControlLabel checked={phoneIcon==='home'}  value="home" control={<Radio color="secondary" onChange={handleChangePhoneIcon} disabled={inProgress}  />} label="خانه" />
                <FormControlLabel checked={phoneIcon==='work'}  value="work" control={<Radio color="secondary" onChange={handleChangePhoneIcon}  disabled={inProgress} />} label="محل کار" />
            </RadioGroup>
            </form>
    </YesNo>
    </>
  )
}

export default React.memo(EditPhone)